import React from 'react';
import { CheckCircle, Mail, DollarSign, Truck } from 'lucide-react';
import { Button } from './ui/Button';
interface ProcessProps {
  onJoinClick?: () => void;
}
const steps = [{
  icon: CheckCircle,
  number: '1',
  title: 'Join the Priority List',
  description: 'Sign up for priority access and lock in early bird pricing before we open.'
}, {
  icon: Mail,
  number: '2',
  title: "We'll Keep You Updated",
  description: "We'll be in touch as we get closer to our opening date with site details."
}, {
  icon: DollarSign,
  number: '3',
  title: 'Confirm Your Booking',
  description: 'Storage capacity will be limited. When pricing is confirmed, bays will be offered to early registrants first, subject to availability.'
}, {
  icon: Truck,
  number: '4',
  title: 'Drop Off Your Vehicle',
  description: 'Bring your caravan, boat or motorhome to its new secure home and enjoy peace of mind.'
}];
export function Process({
  onJoinClick
}: ProcessProps) {
  return <section className="pt-20 pb-10 bg-gradient-to-b from-gray-50 to-white" data-id="element-411">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-412">
        {/* Transparency Message */}
        <div className="text-center mb-16" data-id="element-413">
          <div className="inline-block bg-[#175445]/10 text-[#175445] px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wider mb-6" data-id="element-414">
            New Launch
          </div>
          <h2 className="text-3xl md:text-5xl font-display font-bold text-gray-900 mb-6" data-id="element-415">
            How it works
          </h2>
          <div className="h-1 w-24 bg-[#FFC107] mx-auto rounded-full mb-6" data-id="element-416"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-417">
            We're caravan and boat enthusiasts finalising location and pricing
            for our first Hold My Van storage site within 35kms of Perth CBD.
            Register your interest now to secure priority access and early bird
            pricing.
          </p>
        </div>

        {/* Process Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-418">
          {steps.map((step, index) => <div key={index} className="relative" data-id="element-419">
              {/* Connector Line (hidden on mobile, shown on larger screens) */}
              {index < steps.length - 1 && <div className="hidden lg:block absolute top-12 left-[60%] w-[80%] h-0.5 bg-[#175445]/20 z-0" data-id="element-420"></div>}

              <div className="relative z-10 text-center" data-id="element-421">
                {/* Icon Circle */}
                <div className="inline-flex items-center justify-center w-24 h-24 bg-[#175445] text-[#fbf7dd] rounded-full mb-6 shadow-lg" data-id="element-422">
                  <step.icon className="h-10 w-10" data-id="element-423" />
                </div>

                {/* Step Number */}
                <div className="absolute top-0 right-[calc(50%-3rem)] bg-[#FFC107] text-black w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm shadow-md" data-id="element-424">
                  {step.number}
                </div>

                <h3 className="text-xl font-display font-bold text-gray-900 mb-3" data-id="element-425">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-426">
                  {step.description}
                </p>
              </div>
            </div>)}
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-427">
          <Button variant="secondary" size="lg" className="text-lg px-12 py-6 shadow-xl" onClick={onJoinClick} data-id="element-428">
            Join The Priority List
          </Button>
          <p className="mt-4 text-sm text-gray-500" data-id="element-429">
            Registering your interest does not commit you to a booking. Lock in
            early bird pricing
          </p>
        </div>
      </div>
    </section>;
}